import React, { useRef, useState } from "react"
import isNumeric from "validator/lib/isNumeric"

import Select from "./Select"
import { getUserList } from "services"
import { formatMobilePhone } from "utils"

const UsersSelectFilter = props => {
  const {
    onChange,
    value,
    label,
    role,
    placeholder,
    ...otherProps
  } = props

  const [initialUserList, setInitialUserList] = useState(null)

  const timeout = useRef()
  const unmount = useRef(false)

  const getInitialAccessList = async () => {
    if (initialUserList !== null) return

    const queries = { limit: 5 }

    if (role) queries.role = role

    try {
      const { data } =
        await getUserList(queries)

      if (unmount.current) return

      setInitialUserList(
        data.map(user => ({
          value: user._id,
          label: `${user.fullName} ${user.mobilePhone ? `(${formatMobilePhone(user.mobilePhone)})` : ""}`,
          data: user
        }))
      )

    } catch (err) {
      console.log(err)
    }
  }

  const handleSearch = (inputValue, callback) => {
    clearTimeout(timeout.current)

    timeout.current =
      setTimeout(async () => {
        const queries = { limit: 5 }

        if (role) queries.role = role

        if (isNumeric(inputValue)) {
          queries.mobilePhone = `+98${inputValue.substring(1)}`
        } else {
          queries.fullName = inputValue

          queries.username = inputValue
        }

        const { data: users } = await getUserList(queries)

        callback(users.map(user => ({
          label: `${user.fullName} ${user.mobilePhone ? `(${formatMobilePhone(user.mobilePhone)})` : ""}`,
          value: user._id,
          data: user
        })))
      }, 600)
  }

  return (
    <Select
      async
      isClearable
      label={label}
      placeholder={placeholder}
      loadOptions={handleSearch}
      noOptionsMessage={() => null}
      value={value}
      onChange={onChange}
      onFocus={getInitialAccessList}
      defaultOptions={initialUserList}
      {...otherProps}
    />
  )
}

export default UsersSelectFilter
